angular.module('dpw.services')
    .provider('menuService', function () {
        function hasActivateChild(menuItem, pathname) {
            var hasItemMatched = function (items) {
                return Array.isArray(items) && items.some(function (item) {
                    var itemPathname = item.href.replace(/\?.*|#.*$/, '');

                    return itemPathname && (
                        itemPathname === pathname || _.startsWith(pathname, itemPathname + '/')
                    );
                });
            };

            return Array.isArray(menuItem.groups) && menuItem.groups.some(function (group) {
                var isGroupTitleLinkMatched = group.href && hasItemMatched([group]);

                return isGroupTitleLinkMatched ||
                    hasItemMatched(group.items) ||
                    hasItemMatched(group.extra);
            });
        }

        this.$get = [
            '$window', 'api', 'mixpanelService', 'helpers', 'user', 'supportCaseService', '$q',
            function ($window, api, mixpanelService, helpers, userService, supportCaseService, $q) {
                var deferredProductStore = $q.defer();

                var _states = {
                    primaryItems: [],
                    productStorePromise: deferredProductStore.promise,
                    productFilterState: {
                        partner: '',
                        productFamily: '',
                        regions: []
                    }
                };

                var _utils = {
                    loadMenu: function () {
                        return $q(function (resolve) {
                            api.call(api.contentful.menu(), function (res) {
                                resolve(res);
                            });
                        });
                    },

                    updatePrimaryItems: function (elementMenuItems) {
                        _states.primaryItems = _utils.buildPrimaryItems(elementMenuItems);
                    },

                    buildPrimaryItems: function (elementMenuItems) {
                        var sortedElementMenuItems = (elementMenuItems || [])
                            .filter(function (elementMenuItem) {
                                return elementMenuItem.menuType === 'Header';
                            })
                            .sort(function (a, b) {
                                return a.menuOrder - b.menuOrder;
                            });

                        return sortedElementMenuItems.map(function (elementMenuItem) {
                            var elementMenuLink = _utils.normalizeLink(elementMenuItem.menuLink);

                            var primaryItem = {
                                text: elementMenuItem.menuTitle,
                                href: elementMenuLink,
                                target: helpers.isAbsoluteUrl(elementMenuLink) ? '_blank' : '_self'
                            };

                            var menuBlocks = elementMenuItem.menuBlocks;
                            var withProductFilter = elementMenuItem.showProductFamilies;
                            var withMenuBlocks = Array.isArray(menuBlocks) && menuBlocks.length > 0;
                            var hasSecondaryMenu = withProductFilter || withMenuBlocks;

                            var secondaryItem = {};

                            if (withProductFilter) {
                                secondaryItem.withProductFilter = true;
                                secondaryItem.sections = [
                                    {
                                        isForProductFilterResults: true,
                                        groups: []
                                    },
                                    {
                                        heading: 'Resources',
                                        isForResourcesDisplay: true,
                                        groups: []
                                    }
                                ];
                            }

                            if (withMenuBlocks) {
                                var sectionsFromMenuBlocks = _utils.buildSectionsForSecondaryItem(menuBlocks);
                                secondaryItem.sections = []
                                    .concat(secondaryItem.sections || [])
                                    .concat(sectionsFromMenuBlocks);
                            }

                            if (hasSecondaryMenu) {
                                primaryItem.secondary = secondaryItem;
                            }

                            return primaryItem;
                        });
                    },

                    buildSectionsForSecondaryItem: function (menuBlockItems) {
                        var groups = (menuBlockItems || []).map(function (menuBlockItem) {
                            var groupHeading = menuBlockItem.sectionTitle;

                            var sortedElementMenuItems = (menuBlockItem.sectionsLinks || [])
                                .filter(function (elementMenuItem) {
                                    return elementMenuItem.menuType === 'Inline';
                                })
                                .sort(function (a, b) {
                                    return a.menuOrder - b.menuOrder;
                                });

                            var groupLinkItems = sortedElementMenuItems
                                .filter(function (elementMenuItem) {
                                    return !!elementMenuItem.menuTitle;
                                })
                                .map(function (elementMenuItem) {
                                    var linkItem = {
                                        label: elementMenuItem.menuTitle,
                                        href: _utils.normalizeLink(elementMenuItem.menuLink)
                                    };

                                    _utils.resolveLink(linkItem, 'Top Menu');
                                    return linkItem;
                                });

                            return {
                                heading: groupHeading,
                                items: groupLinkItems
                            };
                        });

                        var primarySection = {
                            groups: groups
                        };

                        return [primarySection];
                    },

                    resolveLink: function (linkItem, page) {
                        var resolvers = {
                            'Create a ticket': function (item, page) {
                                item.href = RCDPW.entries.supportCreateCase.href;
                                item.target = '_self';

                                item.onClick = function (event) {
                                    event.preventDefault();

                                    mixpanelService.track(mixpanelService.eventNames.ACTION, {
                                        'Page Name': page,
                                        'Action Name': 'Create Support Ticket'
                                    });

                                    window.open(item.href, item.target);
                                };
                            },
                            'View your tickets': function (item) {
                                item.href = RCDPW.entries.supportCheckCase.href;
                                item.target = '_blank';

                                userService.fetch().then(function () {
                                    var user = userService.getUser();
                                    item.hidden = user.isPartner;
                                });

                                item.onClick = function (event) {
                                    mixpanelService.trackPageView('View Support Tickets');
                                    supportCaseService.check(event);
                                };
                            }
                        };

                        var label = linkItem.label;
                        var resolver = resolvers[label];

                        if (resolver) {
                            resolver(linkItem, page);
                        }
                    },

                    updateProductStore: function (corePartnerItems) {
                        var productStore = _utils.buildProductStore(corePartnerItems);
                        deferredProductStore.resolve(productStore);
                    },

                    buildProductStore: function (corePartnerItems) {
                        var partnerItems = (corePartnerItems || []).map(function (corePartnerItem) {
                            var partnerPlanMapping = corePartnerItem.partnerPlanMapping || {};
                            var productFamilyNameMappings = partnerPlanMapping.productfamilies || {};

                            return {
                                partnerName: corePartnerItem.partnerName,
                                productFamilies: _utils.buildProductFamilyItems(
                                    corePartnerItem.partnerOfferings,
                                    corePartnerItem.partnerProductExclusions,
                                    productFamilyNameMappings
                                )
                            };
                        });

                        var productStore = {};

                        partnerItems.forEach(function (partnerItem) {
                            productStore[partnerItem.partnerName] = partnerItem;
                        });

                        return productStore;
                    },

                    buildProductFamilyItems: function (coreProductFamiliesItems,
                                                       partnerProductExclusions,
                                                       productFamilyNameMappings) {
                        return (coreProductFamiliesItems || []).map(function (coreProductFamiliesItem) {
                            var originalFamilyName = coreProductFamiliesItem.familyName;
                            var mappedFamilyName = productFamilyNameMappings[originalFamilyName];

                            return {
                                familyName: mappedFamilyName || originalFamilyName,
                                products: _utils.buildProductItems(coreProductFamiliesItem.productsInFamily, partnerProductExclusions),
                                resources: coreProductFamiliesItem.productFamilyResources || []
                            };
                        });
                    },

                    buildProductItems: function (coreProductItems, productExclusions) {
                        var sourceItems = coreProductItems || [];
                        var filteredItems = _.isEmpty(productExclusions)
                            ? sourceItems
                            : sourceItems.filter(function (item) {
                                return !productExclusions.some(function (exclusion) {
                                    return exclusion.entryId === item.entryId;
                                });
                            });
                        return filteredItems.map(function (coreProductItem) {
                            return {
                                productName: coreProductItem.productName,
                                plansSupported: coreProductItem.plansSupported || [],
                                regionsSupported: coreProductItem.regionsSupported || [],
                                showInNavigation: coreProductItem.showInProductNavigation,
                                resourceLinks: _utils.buildProductResourceLinkItems(coreProductItem.productMenuLinks)
                            };
                        });
                    },

                    buildProductResourceLinkItems: function (productMenuLinks) {
                        return (productMenuLinks || []).map(function (productMenuLink) {
                            return {
                                label: productMenuLink.ctaText,
                                href: productMenuLink.ctaUrl
                            };
                        });
                    },

                    onProductFilterStateChanged: function (newState) {
                        var primaryItemWithProductFilter = _states.primaryItems.find(function (item) {
                            return item.secondary && item.secondary.withProductFilter;
                        });

                        if (!primaryItemWithProductFilter) {
                            return;
                        }

                        var allSections = primaryItemWithProductFilter.secondary.sections;

                        _utils.searchProducts(newState).then(function (products) {
                            products = products.filter(function (product) {
                                return product.showInNavigation;
                            });

                            _utils.updateGroupsInSection(
                                allSections,
                                function (section) {
                                    return (section || {}).isForProductFilterResults;
                                },
                                _utils.buildGroupsFromProducts(products)
                            );
                        });

                        _utils.searchResources(newState).then(function (menuBlockItems) {
                            _utils.updateGroupsInSection(
                                allSections,
                                function (section) {
                                    return (section || {}).isForResourcesDisplay;
                                },
                                _utils.buildGroupsFromResources(menuBlockItems)
                            );
                        });
                    },

                    searchProducts: function (criteria) {
                        var partner = _.get(criteria, 'partner');
                        var productFamily = _.get(criteria, 'productFamily');
                        var regions = _.get(criteria, 'regions', []);

                        return service.getProductStore().then(function (productStore) {
                            var productFamilyItem = service.getProductFamilyItem(productStore, partner, productFamily);

                            if (!productFamilyItem) {
                                return [];
                            }

                            if (regions.length === 0) {
                                return productFamilyItem.products;
                            }

                            return _.filter(productFamilyItem.products, function (product) {
                                return _.every(regions, function (region) {
                                    return _.includes(product.regionsSupported, region);
                                });
                            });
                        });
                    },

                    searchResources: function (criteria) {
                        var partner = _.get(criteria, 'partner');
                        var productFamily = _.get(criteria, 'productFamily');

                        return service.getProductStore().then(function (productStore) {
                            var productFamilyItem = service.getProductFamilyItem(productStore, partner, productFamily);
                            return productFamilyItem ? productFamilyItem.resources : [];
                        });
                    },

                    buildGroupsFromProducts: function (products) {
                        return _.map(products, function (product) {
                            var resourceLinks = product.resourceLinks;

                            var menuLinks = (resourceLinks || [])
                                .filter(function (resourceLink) {
                                    return !!resourceLink.label;
                                })
                                .map(function (resourceLink) {
                                    return {
                                        label: resourceLink.label,
                                        href: _utils.normalizeLink(resourceLink.href)
                                    };
                                });

                            return {
                                heading: product.productName,
                                items: menuLinks
                            };
                        });
                    },

                    buildGroupsFromResources: function (menuBlockItems) {
                        if (Array.isArray(menuBlockItems)) {
                            return menuBlockItems.map(function (menuBlockItem) {
                                var menuLinks = (menuBlockItem.sectionsLinks || [])
                                    .filter(function (elementMenuItem) {
                                        return !!elementMenuItem.menuTitle;
                                    })
                                    .map(function (elementMenuItem) {
                                        return {
                                            label: elementMenuItem.menuTitle,
                                            href: _utils.normalizeLink(elementMenuItem.menuLink)
                                        };
                                    });

                                return {
                                    heading: menuBlockItem.sectionTitle,
                                    items: menuLinks
                                };
                            });
                        }

                        return [];
                    },

                    updateGroupsInSection: function (allSections, predicate, groups) {
                        var targetSection = _.find(allSections, predicate);

                        if (targetSection) {
                            targetSection.groups = groups;
                        }
                    },
                    normalizeLink: function (url) {
                        return (url || '').trim();
                    }
                };

                var service = {
                    init: function () {
                        _utils.loadMenu().then(function (res) {
                            _utils.updatePrimaryItems(res.elementMenu);
                            _utils.updateProductStore(res.corePartner);
                        });
                    },

                    getPrimaryItems: function () {
                        return _states.primaryItems;
                    },

                    get404NavItems: function () {
                        return service.getPrimaryItems();
                    },

                    getProductStore: function () {
                        return _states.productStorePromise;
                    },

                    getPartnerItem: function (productStore, id) {
                        return _.get(productStore, id);
                    },

                    getProductFamilyItem: function (productStore, partnerId, productFamilyName) {
                        var partnerItem = service.getPartnerItem(productStore, partnerId);

                        if (!partnerItem) {
                            return;
                        }

                        var productFamilies = partnerItem.productFamilies;

                        return _.find(productFamilies, function (item) {
                            return item.familyName === productFamilyName;
                        });
                    },

                    getProductFilterState: function () {
                        return _states.productFilterState;
                    },

                    updateProductFilterState: function (newState) {
                        _states.productFilterState = newState;
                        _utils.onProductFilterStateChanged(newState);
                    },

                    onPrimaryItemsUpdated: function () {

                    },

                    getClassNamesBaseOn: function (text, basic) {
                        var identifier = text.replace(/[. &#]/g, '_').toLowerCase();
                        return [basic, basic + '-' + identifier];
                    },

                    onItemClick: function (item, $event) {
                        $event.preventDefault();
                        this.trackPageViewForMixpanel(item);

                        if (_.isFunction(item.click)) {
                            item.click($event);
                        }

                        var isOpenInNewWindow = helpers.isNewTabKey($event) || item.target === '_blank';

                        if (item.href) {
                            isOpenInNewWindow ?
                                $window.open(item.href, '_blank') :
                                ($window.location.href = item.href);
                        }
                    },

                    trackPageViewForMixpanel: function (menuItem) {
                        if (menuItem.pageNameForMixpanel) {
                            mixpanelService.trackPageView(menuItem.pageNameForMixpanel);
                        }
                    },

                    hasActivateChild: hasActivateChild,
                    resolveLink: _utils.resolveLink
                };

                return service;
            }
        ];
    });
